import Nullstack from 'nullstack';
export default function IconHandSanitizer({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-hand-sanitizer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 21h10v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10z"
  }), "   ", Nullstack.element("path", {
    d: "M15 3h-6a2 2 0 0 0 -2 2"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v5"
  }), "   ", Nullstack.element("path", {
    d: "M12 11v4"
  }), "   ", Nullstack.element("path", {
    d: "M10 13h4"
  }), " ");
}